export class Cache {
  static readonly DEFAULT_TTL: number = 10 * 1000

  static readonly ETERNITY_TTL: number = 100 * 365 * 24 * 60 * 60 * 1000

  ttl = 0

  data: Record<string, any> = {}

  constructor(ttl: number) {
    this.ttl = ttl
  }

  // eslint-disable-next-line class-methods-use-this
  now() {
    return new Date().getTime()
  }

  nuke(key: string) {
    delete this.data[key]
    return this
  }

  get(key: string) {
    let val = null
    const obj = this.data[key]
    if (obj) {
      if (obj.expires === 0 || this.now() < obj.expires) {
        val = obj.val
      } else {
        val = null
        this.nuke(key)
      }
    }
    console.log('getCache', key, val)
    return val
  }

  getByCreate(key: string, create: () => [any, number]) {
    let val = this.get(key)
    if (val) {
      return val
    }
    const [v, ttl] = create()
    this.put(key, v, ttl)
    val = v

    return val
  }

  async getByCreateAsync(key: string, create: () => [Promise<any>, number]) {
    let val = this.get(key)
    if (val) {
      return val
    }
    const [v, ttl]: [Promise<any>, number] = create()
    const result = await v
    this.put(key, result, ttl)
    val = v
    return val
  }

  del(key: string) {
    const oldVal = this.get(key)
    this.nuke(key)
    return oldVal
  }

  put(key: string, val: any = null, ttl = 0) {
    if (ttl === 0)
      // eslint-disable-next-line no-param-reassign
      ttl = this.ttl

    const expires = ttl === 0 ? 0 : this.now() + ttl
    const oldVal = this.del(key)
    if (val !== null) {
      this.data[key] = {
        expires,
        val,
      }
    }
    return oldVal
  }
}

export const browserCache = new Cache(Cache.DEFAULT_TTL)
